interface IBooleanCellProps {
  value: boolean | null | undefined,
  emptyFalse?: boolean,
  nullLabel?: string,
}

const BooleanCell = ({ value, emptyFalse, nullLabel = '-' }: IBooleanCellProps) => {
  if (value === null || value === undefined) {
    return (<>{ nullLabel }</>);
  }

  if (!value && emptyFalse) {
    return (<>-</>);
  }

  return (<>{ value ? 'Yes' : 'No' }</>);
};

export default BooleanCell;
